import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "children", "content", "active", "index", "duration"];
import React, { useContext } from 'react';
import { Accordion as SemanticUiAccordion } from 'semantic-ui-react';
import _isBoolean from 'lodash/isBoolean';
import { classNames } from '../../../../../../utils/classname';
import AnimateHeight from '../../../../../animations/components/AnimatedElement/variants/AnimateHeight';
import useSemanticUiProps from '../../../../hooks/use-semantic-ui-props';
import { ChildrenPropType } from '../../../../types/component';
import { DEFAULT_SLIDE_ANIMATION_DURATION } from '../../Accordion.constants';
import { AccordionContext } from '../../Accordion.context';
var defaultProps = {
  className: '',
  children: null,
  content: null,
  active: undefined,
  index: undefined,
  duration: DEFAULT_SLIDE_ANIMATION_DURATION
};
export default function Content(_ref) {
  var className = _ref.className,
    children = _ref.children,
    content = _ref.content,
    active = _ref.active,
    index = _ref.index,
    duration = _ref.duration,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(AccordionContext),
    activeIndexes = _useContext.activeIndexes;
  var _useSemanticUiProps = useSemanticUiProps(),
    getAccordionContentProps = _useSemanticUiProps.getAccordionContentProps;
  function isActive() {
    if (_isBoolean(active)) {
      return active;
    }
    return activeIndexes.includes(index);
  }
  var finalClassName = classNames(_defineProperty({
    'accordion-content': true
  }, className, true));
  var AccordionContent = /*#__PURE__*/React.createElement(SemanticUiAccordion.Content, _extends({}, getAccordionContentProps(props), {
    active: isActive(),
    index: index,
    className: finalClassName
  }), content || children);
  if (!duration) {
    return AccordionContent;
  }
  return /*#__PURE__*/React.createElement(AnimateHeight, {
    className: "animated-content",
    duration: duration,
    height: isActive() ? 'auto' : 0
  }, AccordionContent);
}
Content.defaultProps = defaultProps;